export const CommonDataActionConst = {
    GET_COMMON_MASTER_DATA_REQ: "GET_COMMON_MASTER_DATA_REQ",
    GET_COMMON_MASTER_DATA_SUCCESS: "GET_COMMON_MASTER_DATA_SUCCESS",
    GET_COMMON_MASTER_DATA_FAIL: "GET_COMMON_MASTER_DATA_FAIL",
}


export const SupportStaffStepsChangeActionConst = {
    SUPPORT_STAFF_CREATE_STEP: "SUPPORT_STAFF_CREATE_STEP",
}



export const SelectedSessionIdActionConst = {
    SELECTED_SESSION_ID: "SELECTED_SESSION_ID",

}